import Api from './Api';

const Users = () => {
  return Api().get('/users');
};

const User = (id) => {
  return Api().get(`/users/${id}`);
};

const AddUser = (data) => {
  return Api().post('/users/register', data);
};

const RemoveUsers = (id) => {
  return Api().delete(`/users/${id}`);
};

const EditUser = (id, data) => {
  return Api().put(`/users/${id}`, data);
};

const EditUserImage = (id, data) => {
  return Api().put(`/users/image/${id}`, data);
};

const ConfirmUser = (registerToken, data) => {
  return Api().post(`/users/confirm-user/${registerToken}`, data);
};

export {
  Users,
  User,
  RemoveUsers,
  EditUser,
  AddUser,
  ConfirmUser,
  EditUserImage,
};
